import * as React from 'react';
import styled from 'styled-components';

import { MagicIcon } from '../../icons/Icons';

import { HexButton } from './cells/sharedStyles';

const Wrapper = styled.div`
  display: flex;
  border-radius: 2px;
  border: 1px solid #c84654;
  padding: 10px 15px;
  flex: 1 1 auto;
  margin: 10px;
  box-shadow: inset 3px 0 0 #c84654;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: auto;
  line-height: initial;
  gap: 3px;
`;

const Title = styled.div`
  font-size: ${({ theme }) => theme.fontSize.SMALL};
`;

const Description = styled.div`
  color: ${({ theme }) => theme.appUI.fontColor.MUTED};
  font-size: ${({ theme }) => theme.fontSize.SMALL};
`;

interface ErrorOutputProps {
  description: string;
  title: string;
}

export const ErrorOutput: React.ComponentType<ErrorOutputProps> = React.memo(
  ({ title, description }) => {
    return (
      <Wrapper>
        <Info>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Info>
        <HexButton>
          <MagicIcon /> Magic fix
        </HexButton>
      </Wrapper>
    );
  }
);
